/**
 *
 * PortalNoElementFound
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 16-Nov-2022
 */

import React from 'react';
import  leafImage from 'Assets/images/png/leaf.png';
import { Grid, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import formattedMessages from './languageModule';
import PropTypes from 'prop-types';
import style from './PortalNoElementFound.scss';

const PortalNoElementFound = (props) => {
  const intl = useIntl();
  return (
    <Grid className={style.container}>
      <img src={leafImage} />
      <Typography className={style.text} variant='body1'>
        {intl.formatMessage(
          props.customMessage ? props.customMessage : formattedMessages.defaultMessage,
        )}
      </Typography>
    </Grid>
  );
};

PortalNoElementFound.propTypes = {
  customMessage: PropTypes.oneOfType([PropTypes.exact({ id: PropTypes.string }), PropTypes.string]),
};

PortalNoElementFound.defaultProps = {
  // Add here some default propTypes values
};

export default PortalNoElementFound;
